import backofficeService from '../../../api/backoffice'
// let cacheVendor = null

export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  async getAll(params) {
    // if (cacheVendor) return cacheVendor
    return backofficeService.Api().get('vendor', {
        params
      })
      .then(response => {
        // cacheVendor = response.data
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
   /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  syncBalance(id) {
    return backofficeService.Api().get(`vendor/syncBalance/${id}`)
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`vendor/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('vendor', data)
      .then(response => {
        // cacheVendor = null
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`vendor/${id}`, data)
      .then(response => {
        // cacheVendor = null
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`vendor/${id}`, {
        params
      })
      .then(response => {
        // cacheVendor = null
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },

}